import { Injectable } from '@angular/core';
import { config } from 'src/app/app.config';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() { }

  setStorage(name: any, value: any) {
    window.localStorage.setItem(config.baseURL + `/${name}`, value.toString());
  }

  getStorage(name: any): Promise<any> {
    return new Promise((reslove: any) => {
      reslove(window.localStorage.getItem(config.baseURL + `/${name}`));
    });
  }
}
